/* GASH theme scripts: page fade, page loader, product variant + add to bag, photo slider, shop drawer, search */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = window.Shopify && window.Shopify.designMode;

  function closeOverlay(selector, closeSelector) {
    var el = document.querySelector(selector);
    if (el && el.classList.contains('is-open')) {
      var btn = el.querySelector(closeSelector);
      if (btn) btn.click();
    }
  }

  /* ---------- Page loader (centered logo) ---------- */
  /* Arrival animation runs from an inline script in theme.liquid, as early as possible. */
  var loader = document.getElementById('PageLoader');
  function loaderStart() {
    if (!loader || reduce) return;
    loader.classList.remove('is-done');
    loader.classList.add('is-active');
  }

  /* ---------- Page fade between pages ---------- */
  document.addEventListener('click', function (e) {
    if (reduce || inEditor || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    if (a.hasAttribute('data-shop-trigger')) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || a.target === '_blank' || a.hasAttribute('download') || /^(mailto|tel):/.test(href)) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    if (u.pathname === location.pathname && u.search === location.search) return;
    e.preventDefault();
    document.body.classList.add('is-leaving');
    loaderStart();
    try { sessionStorage.setItem('gash-nav', '1'); } catch (err) {}
    setTimeout(function () { location.href = a.href; }, 320);
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.body.classList.remove('is-leaving');
      if (loader) { loader.classList.remove('is-active', 'is-done'); }
    }
  });

  /* ---------- Cart count ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }

  /* ---------- Variant selection ---------- */
  function updateVariant(form) {
    var section = form.closest('[data-product]');
    var script = section && section.querySelector('[data-variants]');
    if (!script) return;
    var variants = JSON.parse(script.textContent);
    var chosen = [];
    form.querySelectorAll('fieldset[data-option]').forEach(function (fs) {
      var c = fs.querySelector('input:checked');
      chosen.push(c ? c.value : null);
    });
    var btn = form.querySelector('[data-add-button]');
    var idInput = form.querySelector('[data-variant-id]');
    if (chosen.indexOf(null) > -1) {
      idInput.value = '';
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-select-label');
      return;
    }
    var match = null;
    variants.forEach(function (v) {
      var ok = true;
      for (var i = 0; i < chosen.length; i++) { if (v.options[i] !== chosen[i]) ok = false; }
      if (ok) match = v;
    });
    if (match && match.available) {
      idInput.value = match.id;
      btn.disabled = false;
      btn.textContent = btn.getAttribute('data-add-label');
    } else {
      idInput.value = '';
      btn.disabled = true;
      btn.textContent = match ? btn.getAttribute('data-soldout-label') : btn.getAttribute('data-select-label');
    }
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.size-input');
    if (!input) return;
    updateVariant(input.closest('form'));
  });

  /* ---------- Add to bag (ajax, falls back to normal form post) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.product-form');
    if (!form) return;
    var idInput = form.querySelector('[data-variant-id]');
    if (!idInput.value) { e.preventDefault(); return; }
    if (!window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-button]');
    btn.disabled = true;
    fetch(window.gash.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(idInput.value), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch(window.gash.cartUrl + '?t=' + Date.now(), { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        btn.textContent = btn.getAttribute('data-added-label');
        setTimeout(function () {
          btn.textContent = btn.getAttribute('data-add-label');
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () { form.submit(); });
  });

  /* ---------- Photo slider ---------- */
  function gState(wrap) {
    var g = wrap.querySelector('.gallery');
    var n = g.children.length;
    var i = Math.min(n - 1, Math.max(0, Math.round(g.scrollLeft / g.clientWidth)));
    var c = wrap.querySelector('[data-gcount]');
    if (c) c.textContent = (i + 1) + ' / ' + n;
    var p = wrap.querySelector('[data-g="-1"]');
    var nx = wrap.querySelector('[data-g="1"]');
    if (p) p.disabled = i === 0;
    if (nx) nx.disabled = i === n - 1;
    return i;
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('gallery')) gState(t.closest('.gallery-wrap'));
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-g]');
    if (!b) return;
    var wrap = b.closest('.gallery-wrap');
    var g = wrap.querySelector('.gallery');
    var n = g.children.length;
    var i = Math.min(n - 1, Math.max(0, gState(wrap) + Number(b.getAttribute('data-g'))));
    g.scrollTo({ left: i * g.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('.gallery-wrap').forEach(gState);
  });

  /* ---------- Shop drawer ---------- */
  var drawer = document.getElementById('ShopDrawer');
  if (drawer) {
    var lastFocus = null;
    function openDrawer() {
      closeOverlay('#SearchPanel', '.search-close');
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('.shop-drawer-close');
      if (closeBtn) closeBtn.focus();
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, reduce ? 0 : 400);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-shop-trigger]');
      if (trigger) {
        e.preventDefault();
        if (drawer.classList.contains('is-open')) { closeDrawer(); } else { openDrawer(); }
        return;
      }
      if (!drawer.classList.contains('is-open')) return;
      var closer = e.target.closest && e.target.closest('[data-shop-close]');
      if (closer) { closeDrawer(); return; }
      var link = e.target.closest && e.target.closest('.shop-drawer-links a');
      if (link) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ---------- Search panel ---------- */
  var searchPanel = document.getElementById('SearchPanel');
  if (searchPanel) {
    var searchInput = document.getElementById('SearchInput');
    var searchResults = document.getElementById('SearchResults');
    var searchLastFocus = null;
    var searchTimer = null;
    var searchToken = 0;

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function clearStatus() {
      var status = searchPanel.querySelector('.search-status');
      if (status) status.remove();
    }

    function runSearch(query) {
      var token = ++searchToken;
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (token !== searchToken) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          clearStatus();
          if (products.length === 0) {
            searchResults.innerHTML = '';
            searchResults.insertAdjacentHTML('afterend', '<p class="search-status">No products found for \u201c' + escapeHtml(query) + '\u201d.</p>');
            return;
          }
          var html = products.map(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            return '<a class="search-result" href="' + p.url + '">' +
              '<span class="search-result-image">' + (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') + '</span>' +
              '<span class="search-result-name">' + escapeHtml(p.title) + '</span>' +
              '<span class="search-result-price">' + (p.price || '') + '</span>' +
            '</a>';
          }).join('');
          searchResults.innerHTML = html;
        })
        .catch(function () {});
    }

    function openSearch() {
      closeOverlay('#ShopDrawer', '.shop-drawer-close');
      searchLastFocus = document.activeElement;
      searchPanel.hidden = false;
      requestAnimationFrame(function () { searchPanel.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      setTimeout(function () { searchInput.focus(); }, reduce ? 0 : 200);
    }
    function closeSearch() {
      searchPanel.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { searchPanel.hidden = true; }, reduce ? 0 : 400);
      searchInput.value = '';
      searchResults.innerHTML = '';
      clearStatus();
      if (searchLastFocus && searchLastFocus.focus) searchLastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-search-trigger]');
      if (trigger) {
        e.preventDefault();
        if (searchPanel.classList.contains('is-open')) { closeSearch(); } else { openSearch(); }
        return;
      }
      if (!searchPanel.classList.contains('is-open')) return;
      var closer = e.target.closest && e.target.closest('[data-search-close]');
      if (closer) { closeSearch(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) closeSearch();
    });
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) {
        searchResults.innerHTML = '';
        clearStatus();
        return;
      }
      searchTimer = setTimeout(function () { runSearch(q); }, 250);
    });
  }
})();
